import { render, staticRenderFns } from "./common-settings.vue?vue&type=template&id=3c2769fe"
import script from "./common-settings.vue?vue&type=script&lang=js"
export * from "./common-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports